import React from "react";

import { useGetCurrentUser } from "api/api-hooks/user-hooks";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {
  MdmObject,
  useCreateObjectMutation,
  useGetProjectByRefNameQuery,
} from "gql/generated/types";
import { useNavigate } from "react-router-dom";
import ObjectForm from "../components/ObjectForm";

const NewObjectForm = () => {
  const navigate = useNavigate();
  const [mutateFunction] = useCreateObjectMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Object updated successfully",
        life: 3000,
      });
      navigate("/");
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
    refetchQueries: ["GetAllObjects"],
  });
  const { data: userData } = useGetCurrentUser();

  const { data: project } = useGetProjectByRefNameQuery({
    variables: { refName: userData?.companyRef! },
  });
  
  const handleCreate = (object: Partial<MdmObject>) => {
    mutateFunction({
      variables: { object: { ...object, projectId: project?.mdmProjectsByCompany[0]?.id } },
    });
  };
  return <ObjectForm object={null} onSubmit={handleCreate} />;
};

export default NewObjectForm;
